<template>
	<div class="d-flex flex-column video-container">
		<button v-on:click="firebaseData">GET DATA</button>

		<section class="video-player flex-shrink-0">
			<video id="vid" class="video" autoplay="true" ref="video">
				<source
					src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4"
					type="video/mp4"
				/>
			</video>
			<img
				src="../../assets/img/av-icn/video-screen.png"
				class="videoimg"
				alt=""
			/>
			<div class="control-top">
				<a
					href="#"
					class="avbtn btn"
					data-toggle="tooltip"
					data-placement="right"
					title="Back To Home"
					><img src="../../assets/img/av-icn/back button.svg" alt="" />
				</a>
			</div>
			<div class="control-bottom">
				<div class="row d-flex align-items-center mb-2">
					<div class="col mr-auto">
						<div class="progress hight4 control">
							<div
								class="progress-bar w-75"
								role="progressbar"
								aria-valuenow="75"
								aria-valuemin="0"
								aria-valuemax="100"
							></div>
						</div>
					</div>
					<div class="col-1 ml-auto pl-0 time">01:53:62</div>
				</div>

				<div class="d-flex justify-content-between">
					<div>
						<ul class="list-unstyled d-flex">
							<li>
								<a class="avbtn btn" @click="resumePlay"
									><img src="../../assets/img/av-icn/play.svg" alt="" />
								</a>
							</li>
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/rewind.svg" alt="" />
								</a>
							</li>
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/fast forward.svg" alt="" />
								</a>
							</li>
							<li class="dropdown dropup show">
								<a
									href="#"
									class="avbtn btn"
									role="button"
									id="dropdownMenuLink"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
									><img src="../../assets/img/av-icn/volume-up.svg" alt="" />
								</a>
								<div
									class="dropdown-menu volume"
									aria-labelledby="dropdownMenuLink"
								>
									<a class="dropdown-item" href="#">
										<img src="../../assets/img/av-icn/volume-bar.svg" alt="" />
									</a>
								</div>
							</li>
							<li>void</li>
						</ul>
					</div>
					<div>
						<ul class="list-unstyled d-flex">
							<li>
								<a
									href="#"
									class="avbtn btn help-outline"
									data-toggle="tooltip"
									data-placement="top"
									title="something wrong? Tell Us"
									><img src="../../assets/img/av-icn/help_outline.svg" alt="" />
								</a>
							</li>
							<li class="dropdown dropup show">
								<a
									href="#"
									class="avbtn btn"
									role="button"
									id="dropdownMenuLink"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
									><img src="../../assets/img/av-icn/subtitles.svg" alt="" />
								</a>
								<div
									class="dropdown-menu data-result"
									aria-labelledby="dropdownMenuLink"
								>
									<div class="d-flex w-100">
										<div class="">
											<a class="dropdown-item" href="#"> Audio </a>
											<a class="dropdown-item" href="#">
												<i class="fa fa-check" aria-hidden="true"></i> English
											</a>
											<a class="dropdown-item of" href="#"> Yoruba </a>
											<a class="dropdown-item of" href="#"> lgbo </a>
										</div>
										<div class="">
											<a class="dropdown-item" href="#"> Subtitles </a>
											<a class="dropdown-item" href="#">
												<i class="fa fa-check" aria-hidden="true"></i>
												English[CC]
											</a>
											<a class="dropdown-item of" href="#"> Off </a>
											<a class="dropdown-item of" href="#"> Yoruba </a>
										</div>
									</div>
								</div>
							</li>
							<li>
								<a href="#" class="avbtn btn"
									><img src="../../assets/img/av-icn/cast.svg" alt="" />
								</a>
							</li>
							<li>
								<button class="avbtn btn">
									<img src="../../assets/img/av-icn/fullscreen.svg" alt="" />
								</button>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Category from "@/components/Category.vue";
import firebase from "../../config";
import duid from "../../service/getDuid";

export default {
	name: "Videoplayer",
	components: {
		Category,
	},

	computed: {
		showplay() {
			if (this.$store.state.globalconfigs.enable_play == "false") {
				return false;
			} else {
				return true;
			}
		},
	},

	filters: {
		trimdis: function(value) {
			return value.slice(0, 80) + "...";
		},
	},

	mounted() {
		//  this.$store.commit("setLoader", true);
		window.scroll(0, 0);
	},

	beforeRouteEnter(to, from, next) {
		//this.$store.commit('setLoader', false);
		next();
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},

	data() {
		return {
			category_data: {},
			showVideo: false,
			currentVideo: {},
			currentCat: "",
			options: null,
			duidVal: null,
			interval: null,
		};
	},
	methods: {
		getDuidValue() {
			this.duidVal = duid.getDuid();
		},

		firebasePushData() {
			const db = firebase
				.database()
				.ref("/ibaka-tv/userid")
				.push({
					device_name: "website", // can get from config device_name
					device_id: this.duidVal, // on load of webapp for first time genrating random string duid and use it
					user_id: "", // can get from account.user.profile.id
					video_id: "", // current video id
					video_name: "", // current video name
					session_id: "", // current video session can get from playback url responce
				});
		},

		firebaseData() {
			this.interval = setInterval(this.firebasePushData, 5000);
		},

		my_favourite() {
			for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
				var item = this.$store.state.user.mylist[i];
				if (item.id == this.currentVideo.id) return true;
			}
			return false;
		},
		resumePlay() {
			this.$store
				.dispatch("getVideoById", this.$route.params.vid)
				.then((res) => {
					this.$store.commit("setresumelistData", [
						res._embedded.collections[0],
					]);
				});
		},
		handleFav() {},
	},
	created() {
		this.$store.commit("showdefaultnav", false);
		this.$store.commit("showdefaultFooter", false);
		this.getDuidValue();
		document.body.requestFullscreen();
		if (this.$store.state.user.logedin == false) {
			this.$store.commit("setLoader", false);
			this.$router.push("/login");
			return false;
		}
		this.$store
			.dispatch("getVideoPlaybackURLV2", "5efcce329bb8b20019b94914")
			.then((res) => {
			})
			.catch(e);
	},
};
</script>

<style scoped>
.video {
	position: absolute;
	width: 100%;
	height: 100%;
}
.details div {
	box-sizing: border-box;
	content: "";
}
.details {
	position: relative;
	width: 100%;
	max-width: 100%;
	margin: 0 auto;
	padding-bottom: 100px;
}
.current-video {
	width: 100%;
}
.cover-image {
	position: relative;
	width: 100%;
	min-height: 100vh;
	background-size: 100% 100%;
	border-bottom: 1px solid #000;
	opacity: 0.5;
}
.video-card {
	background-color: #000000;
	width: 80%;
	margin: 0 auto;
	color: #ffff;
	padding: 20px;
	margin-top: 16px;
	/*box-shadow: 0px 1px 10px 11px rgba(88, 86, 86, 0.5);*/
}
.video-card p {
	margin-bottom: 40px;
}
.recent-carousel {
	margin: 0 auto;
	width: 80%;
	position: relative;
	padding-top: 100px;
}
.gradient-div {
	position: absolute;
	width: 100%;
	bottom: 0px;
	border: 5px solid rgb(0, 0, 0);
	box-shadow: 0px -20px 50px 50px rgb(0, 0, 0);
}
.watchnow {
	padding: 10px;
	font-size: 1.2rem;
	border-radius: 3px;
	cursor: pointer;
	background: transparent;
	color: #fff;
	border: 1px solid #fff;
	text-align: center;
}
@media only screen and (max-width: 600px) {
	.cover-image {
		min-height: 50vh;
	}
	.video-card {
		background-color: #000000;
		width: 90%;
	}
}
</style>
